'use client'
import React, { useState, useEffect } from 'react'
import PhoneWidget from '@/components/PhoneWidget'

const capSet1 = [
  {
    id: 'email',
    icon: 'mail',
    title: 'Email Triage',
    detail: 'Scanning 47 unread...',
    content: '3 urgent — 2 need reply',
    items: ['⚡ Invoice #4821 overdue — auto-sent reminder', '🤝 New lead from LinkedIn — drafted response', '📊 Weekly report compiled & attached'],
    position: 'left-top' as const,
    color: 'from-blue-500/15 to-cyan-500/10',
    border: 'border-blue-400/30',
    glow: 'shadow-blue-500/10',
    accentColor: '#3b82f6',
  },
  {
    id: 'calendar',
    icon: 'calendar',
    title: 'Schedule Manager',
    detail: 'Resolving conflicts...',
    content: '5 meetings — 1 conflict fixed',
    items: ['🔄 Moved Q1 Review to avoid overlap', '📞 Confirmed call with Riyadh office 3PM', '✈️ Booked travel for March conference'],
    position: 'right-top' as const,
    color: 'from-purple-500/15 to-pink-500/10',
    border: 'border-purple-400/30',
    glow: 'shadow-purple-500/10',
    accentColor: '#a855f7',
  },
  {
    id: 'content',
    icon: 'edit',
    title: 'Content Writer',
    detail: 'Drafting article...',
    content: '2 posts scheduled today',
    items: ['📝 Blog post drafted — SEO score 94', '📸 Social captions for 5 platforms', '🌐 Arabic + English versions ready'],
    position: 'left-bottom' as const,
    color: 'from-rose-500/15 to-pink-500/10',
    border: 'border-rose-400/30',
    glow: 'shadow-rose-500/10',
    accentColor: '#f43f5e',
  },
  {
    id: 'research',
    icon: 'search',
    title: 'Market Intel',
    detail: 'Analyzing competitors...',
    content: 'Report ready — 6 insights',
    items: ['📈 Competitor raised prices 12%', '🎯 3 new RFPs matching your services', '📋 47-page report → 1-page summary'],
    position: 'right-bottom' as const,
    color: 'from-emerald-500/15 to-teal-500/10',
    border: 'border-emerald-400/30',
    glow: 'shadow-emerald-500/10',
    accentColor: '#10b981',
  },
  {
    id: 'sales',
    icon: 'trending',
    title: 'Sales Pipeline',
    detail: 'Updating CRM...',
    content: '$24K pipeline — 3 hot leads',
    items: ['🔥 Proposal sent to TechCorp — follow up Wed', '✅ Closed deal #892 — invoice generated', '📱 WhatsApp follow-up sent to 5 prospects'],
    position: 'left-mid' as const,
    color: 'from-amber-500/15 to-orange-500/10',
    border: 'border-amber-400/30',
    glow: 'shadow-amber-500/10',
    accentColor: '#f59e0b',
  },
  {
    id: 'ops',
    icon: 'server',
    title: 'Server Ops',
    detail: 'Health check running...',
    content: 'All systems green ✓',
    items: ['🖥️ SSL renewed — expires Dec 2027', '💾 Database backed up (2.3 GB)', '🚨 Memory leak fixed — uptime restored'],
    position: 'right-mid' as const,
    color: 'from-cyan-500/15 to-blue-500/10',
    border: 'border-cyan-400/30',
    glow: 'shadow-cyan-500/10',
    accentColor: '#06b6d4',
  },
]

const capSet2 = [
  {
    id: 'whatsapp',
    icon: 'chat',
    title: 'WhatsApp Outreach',
    detail: 'Sending follow-ups...',
    content: '34 sent — 12 replied',
    items: [],
    position: 'left-top' as const,
    color: 'from-green-500/15 to-emerald-500/10',
    border: 'border-green-400/30',
    glow: 'shadow-green-500/10',
    accentColor: '#22c55e',
  },
  {
    id: 'invoice',
    icon: 'receipt',
    title: 'Invoice Manager',
    detail: 'Processing invoices...',
    content: '3 sent — $14,200 pending',
    items: [],
    position: 'right-top' as const,
    color: 'from-violet-500/15 to-purple-500/10',
    border: 'border-violet-400/30',
    glow: 'shadow-violet-500/10',
    accentColor: '#8b5cf6',
  },
  {
    id: 'analytics',
    icon: 'chart',
    title: 'Analytics Report',
    detail: 'Compiling weekly KPIs...',
    content: '+18% revenue vs last week',
    items: [],
    position: 'left-bottom' as const,
    color: 'from-orange-500/15 to-amber-500/10',
    border: 'border-orange-400/30',
    glow: 'shadow-orange-500/10',
    accentColor: '#f97316',
  },
  {
    id: 'hr',
    icon: 'users',
    title: 'HR Assistant',
    detail: 'Screening candidates...',
    content: '12 CVs — 3 shortlisted',
    items: [],
    position: 'right-bottom' as const,
    color: 'from-pink-500/15 to-rose-500/10',
    border: 'border-pink-400/30',
    glow: 'shadow-pink-500/10',
    accentColor: '#ec4899',
  },
  {
    id: 'orders',
    icon: 'package',
    title: 'Order Tracker',
    detail: 'Checking shipments...',
    content: '5 active — 2 delayed',
    items: [],
    position: 'left-mid' as const,
    color: 'from-sky-500/15 to-blue-500/10',
    border: 'border-sky-400/30',
    glow: 'shadow-sky-500/10',
    accentColor: '#0ea5e9',
  },
  {
    id: 'translator',
    icon: 'globe',
    title: 'Translator',
    detail: 'Translating content...',
    content: '10 languages — instant',
    items: [],
    position: 'right-mid' as const,
    color: 'from-teal-500/15 to-cyan-500/10',
    border: 'border-teal-400/30',
    glow: 'shadow-teal-500/10',
    accentColor: '#14b8a6',
  },
]

const allCapSets = [capSet1, capSet2]

type Phase = 'idle' | 'traveling' | 'arriving' | 'working' | 'returning'

/* ── EVE Bot with multiple poses ── */
const CARD_WORK_ANIM: Record<string, string> = {
  email:      'animate-eveType',       // typing: forward lean + rapid x-tap
  calendar:   'animate-evePlan',       // look up & point: lean back + tilt
  content:    'animate-eveWrite',      // writing: sway side-to-side
  research:   'animate-eveScan',       // scanning: sweep left→right
  sales:      'animate-eveCelebrate',  // celebrate: big excited jump
  ops:        'animate-eveFix',        // fixing: lean in + tap
  whatsapp:   'animate-eveChat',       // chatting: bounce + side lean
  invoice:    'animate-eveCount',      // counting: systematic nod sequence
  analytics:  'animate-eveAnalyze',   // analyzing: slow head tilt study
  hr:         'animate-eveGreet',      // greeting: bow forward + back
  orders:     'animate-evePoint',      // pointing: lean + scale pulse
  translator: 'animate-eveThink',     // thinking: gentle tilt + pause
}

function EveBot({ phase, direction, cardId }: { phase: Phase; direction: 'left' | 'right'; cardId: string }) {
  const isTraveling = phase === 'traveling'
  const isReturning = phase === 'returning'
  const isMoving = isTraveling || isReturning
  const isWorking = phase === 'working' || phase === 'arriving'
  const isIdle = phase === 'idle'
  const flip = (isTraveling && direction === 'left') || (isReturning && direction === 'right')

  const workAnim = CARD_WORK_ANIM[cardId] ?? 'animate-eveWork'
  const animClass = isIdle
    ? 'animate-eveLaugh'
    : isMoving
    ? 'animate-eveSwim'
    : isWorking
    ? workAnim
    : 'animate-eveFloat'

  return (
    <div className="relative" style={{ width: 73, height: 83 }}>
      <div
        className={`transition-all duration-300 ${animClass}`}
        style={{
          transform: flip ? 'scaleX(-1)' : 'scaleX(1)',
          filter: isWorking
            ? 'drop-shadow(0 0 14px rgba(96,165,250,0.7))'
            : isMoving
            ? 'drop-shadow(0 0 8px rgba(96,165,250,0.4))'
            : isIdle
            ? 'drop-shadow(0 0 6px rgba(167,139,250,0.5))'
            : 'drop-shadow(0 0 4px rgba(96,165,250,0.2))',
        }}
      >
        {/* Preload all poses, show active */}
        <img src="/eve-bot.png" alt="" className={`w-[73px] h-[83px] object-contain absolute inset-0 transition-opacity duration-300 ${!isMoving && !isWorking ? 'opacity-100' : 'opacity-0'}`} />
        <img src="/eve-fly.png" alt="" className={`w-[73px] h-[83px] object-contain absolute inset-0 transition-opacity duration-300 ${isMoving ? 'opacity-100' : 'opacity-0'}`} />
        <img src="/eve-wave.png" alt="" className={`w-[73px] h-[83px] object-contain transition-opacity duration-300 ${isWorking ? 'opacity-100' : 'opacity-0'}`} />
      </div>

      {/* Laugh bubbles when idle */}
      {isIdle && (
        <>
          <span className="absolute -top-3 -right-1 text-[11px] animate-bounce" style={{ animationDuration: '0.6s' }}>😄</span>
          <span className="absolute -top-1 -left-3 text-[9px] opacity-70 animate-bounce" style={{ animationDelay: '0.2s', animationDuration: '0.7s' }}>heh</span>
        </>
      )}

      {/* Sparkles when working */}
      {isWorking && (
        <>
          <span className="absolute -top-2 -right-1 text-[10px] animate-ping">✨</span>
          <span className="absolute top-0 -left-2 text-[10px] animate-ping" style={{ animationDelay: '0.3s' }}>💫</span>
        </>
      )}

      {/* Speed trail when moving */}
      {isTraveling && (
        <div className="absolute top-1/2 -translate-y-1/2 flex gap-1.5"
          style={{ [direction === 'left' ? 'right' : 'left']: '-16px' }}>
          <span className="w-2 h-2 bg-blue-400/50 rounded-full animate-ping" />
          <span className="w-1.5 h-1.5 bg-blue-400/30 rounded-full animate-ping" style={{ animationDelay: '0.1s' }} />
        </div>
      )}
    </div>
  )
}

export default function HeroShowcase() {
  const [activeCard, setActiveCard] = useState(0)
  const [phase, setPhase] = useState<Phase>('idle')
  const [round, setRound] = useState(0)
  const [transitioning, setTransitioning] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const capabilities = allCapSets[round]

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 1024)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  useEffect(() => {
    let cancelled = false
    let cardIndex = 0
    let currentRound = 0

    const startCycle = () => {
      if (cancelled) return
      setActiveCard(cardIndex)
      setPhase('traveling')
      setTimeout(() => { if (!cancelled) setPhase('arriving') }, 480)
      setTimeout(() => { if (!cancelled) setPhase('working') }, 720)
      setTimeout(() => { if (!cancelled) setPhase('returning') }, 2320)
      setTimeout(() => {
        if (cancelled) return
        setPhase('idle')
        const nextIndex = cardIndex + 1
        if (nextIndex >= allCapSets[currentRound].length) {
          // End of round: crossfade to next set
          setTransitioning(true)
          setTimeout(() => {
            if (cancelled) return
            cardIndex = 0
            currentRound = (currentRound + 1) % allCapSets.length
            setRound(currentRound)
            setTimeout(() => {
              if (cancelled) return
              setTransitioning(false)
              setTimeout(startCycle, 100)
            }, 50)
          }, 450)
        } else {
          cardIndex = nextIndex
          setTimeout(startCycle, 150)
        }
      }, 2800)
    }

    startCycle()
    return () => { cancelled = true }
  }, [])

  const getAgentTransform = () => {
    const cap = capabilities[activeCard]
    if (!cap) return {}

    // Mobile: Eve goes diagonally down-left or down-right based on card position
    if (isMobile) {
      const mx = cap.position.startsWith('left') ? -105 : 105
      switch (phase) {
        case 'idle':
          return { transform: 'translate(0px, 0px) scale(0.8)', opacity: 0.7 }
        case 'traveling':
          return { transform: `translate(${mx}px, 250px) scale(0.95)`, opacity: 1 }
        case 'arriving':
          return { transform: `translate(${mx}px, 265px) scale(1.1)`, opacity: 1 }
        case 'working':
          return { transform: `translate(${mx}px, 260px) scale(1.0)`, opacity: 1 }
        case 'returning':
          return { transform: 'translate(0px, 0px) scale(0.8)', opacity: 0.7 }
        default:
          return { transform: 'translate(0px, 0px) scale(0.8)', opacity: 0.7 }
      }
    }

    // Desktop: Eve goes left/right to cards
    const side = cap.position.startsWith('left') ? -1 : 1
    const vert = cap.position.endsWith('top') ? -1 : cap.position.endsWith('mid') ? 0 : 1

    switch (phase) {
      case 'idle':
        return { transform: 'translate(0px, 0px) scale(0.8)', opacity: 0.7 }
      case 'traveling':
        return { transform: `translate(${side * 135}px, ${vert * 85}px) scale(1)`, opacity: 1 }
      case 'arriving':
        return { transform: `translate(${side * 150}px, ${vert * 85}px) scale(1.15)`, opacity: 1 }
      case 'working':
        return { transform: `translate(${side * 150}px, ${vert * 85}px) scale(1)`, opacity: 1 }
      case 'returning':
        return { transform: 'translate(0px, 0px) scale(0.8)', opacity: 0.7 }
      default:
        return { transform: 'translate(0px, 0px) scale(0.8)', opacity: 0.7 }
    }
  }

  const direction = capabilities[activeCard]?.position.startsWith('left') ? 'left' : 'right'

  return (
    <div className="relative w-full max-w-6xl mx-auto">
      <div className="flex flex-col lg:flex-row items-center justify-center gap-2 sm:gap-3 lg:gap-6">
        
        {/* Left cards */}
        <div className={`hidden lg:flex flex-col gap-4 w-64 transition-opacity duration-500 ${transitioning ? 'opacity-0 scale-95' : 'opacity-100 scale-100'}`}>
          {capabilities.filter(c => c.position.startsWith('left')).map((cap) => (
            <CapCard key={cap.id} cap={cap} active={capabilities[activeCard]?.id === cap.id && (phase === 'arriving' || phase === 'working')} highlight={capabilities[activeCard]?.id === cap.id && phase === 'arriving'} />
          ))}
        </div>

        {/* Phone + Eve Bot */}
        <div className="relative flex-shrink-0">
          <div className="absolute inset-0 bg-gradient-to-b from-blue-500/8 via-indigo-500/5 to-transparent blur-3xl scale-150 -z-10" />
          
          {/* Connection lines */}
          {capabilities.map((cap) => {
            const isActive = capabilities[activeCard]?.id === cap.id && (phase === 'traveling' || phase === 'arriving' || phase === 'working')
            const side = cap.position.startsWith('left')
            const top = cap.position.endsWith('top') ? true : cap.position.endsWith('mid') ? null : false
            return (
              <div key={`line-${cap.id}`} className="hidden lg:block absolute transition-all duration-500"
                style={{
                  width: isActive ? '40px' : '16px',
                  height: '2px',
                  borderRadius: '1px',
                  background: isActive
                    ? `linear-gradient(${side ? 'to left' : 'to right'}, ${cap.accentColor}88, transparent)`
                    : 'linear-gradient(to right, rgba(150,150,150,0.15), transparent)',
                  left: side ? '-32px' : undefined,
                  right: !side ? '-32px' : undefined,
                  top: top === true ? '20%' : top === null ? '50%' : '80%',
                }}
              />
            )
          })}

          {/* Animated Eve Bot */}
          <div className="absolute z-20 pointer-events-none"
            style={{ left: '50%', top: '50%', marginLeft: '-24px', marginTop: '-28px', transition: 'transform 400ms cubic-bezier(0.4,0,0.2,1), opacity 280ms ease', ...getAgentTransform() }}>
            <div className={`${phase === 'idle' || phase === 'returning' ? 'animate-eveFloat' : ''}`}>
              <EveBot phase={phase} direction={direction as 'left' | 'right'} cardId={capabilities[activeCard]?.id ?? ''} />
            </div>
          </div>

          {/* Desktop phone */}
          <div className="hidden sm:block scale-[0.85] origin-top">
            <PhoneWidget />
          </div>
          {/* Mobile phone — clipped container to eliminate dead space below */}
          <div className="sm:hidden origin-top" style={{transform: 'scale(0.72)', transformOrigin: 'top center', marginBottom: '-195px'}}>
            <PhoneWidget />
          </div>

          {/* Mobile: active card left or right below phone — mirrors Eve's direction */}
          {isMobile && capabilities[activeCard] && (
            <div
              className={`sm:hidden absolute transition-all duration-500 ${transitioning ? 'opacity-0' : 'opacity-100'}`}
              style={{
                top: '505px',
                ...(capabilities[activeCard].position.startsWith('left')
                  ? { left: '8px' }
                  : { right: '8px' }),
                width: '155px',
                zIndex: 10,
              }}
            >
              <CapCard
                cap={capabilities[activeCard]}
                active={phase === 'arriving' || phase === 'working'}
                highlight={phase === 'arriving'}
              />
            </div>
          )}
        </div>

        {/* Right cards */}
        <div className={`hidden lg:flex flex-col gap-4 w-64 transition-opacity duration-500 ${transitioning ? 'opacity-0 scale-95' : 'opacity-100 scale-100'}`}>
          {capabilities.filter(c => c.position.startsWith('right')).map((cap) => (
            <CapCard key={cap.id} cap={cap} active={capabilities[activeCard]?.id === cap.id && (phase === 'arriving' || phase === 'working')} highlight={capabilities[activeCard]?.id === cap.id && phase === 'arriving'} />
          ))}
        </div>

        {/* Desktop-only (sm+) stacked cards below — hidden on mobile since active card is inside phone container */}
        <div className={`hidden sm:block lg:hidden w-full max-w-md px-3 transition-opacity duration-500 ${transitioning ? 'opacity-0 scale-95' : 'opacity-100 scale-100'}`}>
          <div className="grid grid-cols-2 gap-2.5">
            {capabilities.map((cap) => (
              <CapCard
                key={cap.id}
                cap={cap}
                active={capabilities[activeCard]?.id === cap.id && (phase === 'arriving' || phase === 'working')}
                highlight={capabilities[activeCard]?.id === cap.id && phase === 'arriving'}
              />
            ))}
          </div>
        </div>
      </div>

      <style jsx global>{`
        @keyframes eveFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes eveSwim {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          25% { transform: translateY(-3px) rotate(-4deg); }
          75% { transform: translateY(3px) rotate(4deg); }
        }
        @keyframes eveWork {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-2px) rotate(2deg); }
        }
        @keyframes eveLaugh {
          0%   { transform: translateY(0) rotate(0deg) scale(1); }
          10%  { transform: translateY(-10px) rotate(-6deg) scale(1.12); }
          20%  { transform: translateY(-5px) rotate(5deg) scale(1.06); }
          30%  { transform: translateY(-9px) rotate(-4deg) scale(1.10); }
          40%  { transform: translateY(-3px) rotate(3deg) scale(1.04); }
          50%  { transform: translateY(-7px) rotate(-3deg) scale(1.08); }
          65%  { transform: translateY(-2px) rotate(2deg) scale(1.02); }
          80%  { transform: translateY(-5px) rotate(-2deg) scale(1.05); }
          100% { transform: translateY(0) rotate(0deg) scale(1); }
        }
        @keyframes eveSpin {
          0%   { transform: rotate(0deg) scale(1); }
          25%  { transform: rotate(90deg) scale(0.85); }
          50%  { transform: rotate(180deg) scale(0.75); }
          75%  { transform: rotate(270deg) scale(0.85); }
          100% { transform: rotate(360deg) scale(1); }
        }
        /* 12 unique card-work animations — clean single-axis, distinct rhythms */

        /* email — rapid tap nod (busy, focused) */
        @keyframes eveType {
          0%,100% { transform: translateY(0) rotate(0deg); }
          30%     { transform: translateY(5px) rotate(-4deg); }
          60%     { transform: translateY(5px) rotate(4deg); }
          80%     { transform: translateY(2px) rotate(-2deg); }
        }
        /* calendar — gentle think-float (considering) */
        @keyframes evePlan {
          0%,100% { transform: translateY(0) scale(1); }
          40%     { transform: translateY(-9px) scale(1.09); }
          70%     { transform: translateY(-5px) scale(1.05); }
        }
        /* content — smooth writing sway (creative) */
        @keyframes eveWrite {
          0%,100% { transform: rotate(0deg); }
          33%     { transform: rotate(-9deg); }
          66%     { transform: rotate(8deg); }
        }
        /* research — left-right head scan (studying) */
        @keyframes eveScan {
          0%,12%,100% { transform: rotate(0deg); }
          28%,42%     { transform: rotate(-11deg); }
          62%,76%     { transform: rotate(11deg); }
        }
        /* sales — excited celebration hop (pumped) */
        @keyframes eveCelebrate {
          0%,100% { transform: translateY(0) scale(1); }
          25%     { transform: translateY(-13px) scale(1.16); }
          55%     { transform: translateY(-7px) scale(1.08); }
          75%     { transform: translateY(-11px) scale(1.13); }
        }
        /* ops — precision focus lean (concentrating) */
        @keyframes eveFix {
          0%,100% { transform: rotate(0deg) scale(1); }
          40%     { transform: rotate(11deg) scale(0.94); }
          70%     { transform: rotate(9deg) scale(0.96); }
        }
        /* whatsapp — quick happy bounce (messaging energy) */
        @keyframes eveChat {
          0%,100% { transform: translateY(0); }
          25%     { transform: translateY(-10px); }
          50%     { transform: translateY(-4px); }
          75%     { transform: translateY(-8px); }
        }
        /* invoice — rhythmic count nod (methodical) */
        @keyframes eveCount {
          0%,100% { transform: translateY(0) rotate(0deg); }
          20%     { transform: translateY(6px) rotate(-3deg); }
          40%     { transform: translateY(0) rotate(0deg); }
          60%     { transform: translateY(6px) rotate(-3deg); }
          80%     { transform: translateY(0) rotate(0deg); }
        }
        /* analytics — slow tilt & hold (deep analysis) */
        @keyframes eveAnalyze {
          0%,20%,100% { transform: rotate(0deg); }
          40%,72%     { transform: rotate(15deg); }
        }
        /* hr — warm greeting bow (welcoming) */
        @keyframes eveGreet {
          0%,100% { transform: rotate(0deg) translateY(0); }
          35%     { transform: rotate(-16deg) translateY(4px); }
          65%     { transform: rotate(-11deg) translateY(2px); }
        }
        /* orders — eager forward lean (on it!) */
        @keyframes evePoint {
          0%,100% { transform: translateY(0) rotate(0deg); }
          30%     { transform: translateY(8px) rotate(9deg); }
          65%     { transform: translateY(4px) rotate(5deg); }
        }
        /* translator — slow ponder & pause (thinking deeply) */
        @keyframes eveThink {
          0%,18%,58%,100% { transform: rotate(0deg); }
          32%,48%         { transform: rotate(17deg); }
        }

        .animate-eveFloat     { animation: eveFloat     2.5s  ease-in-out infinite; }
        .animate-eveSwim      { animation: eveSwim      0.5s  ease-in-out infinite; }
        .animate-eveWork      { animation: eveWork      0.8s  ease-in-out infinite; }
        .animate-eveLaugh     { animation: eveLaugh     1.4s  ease-in-out infinite; }
        .animate-eveSpin      { animation: eveSpin      0.55s linear     infinite; }
        .animate-eveType      { animation: eveType      0.45s ease-in-out infinite; }
        .animate-evePlan      { animation: evePlan      1.3s  ease-in-out infinite; }
        .animate-eveWrite     { animation: eveWrite     1.0s  ease-in-out infinite; }
        .animate-eveScan      { animation: eveScan      1.8s  ease-in-out infinite; }
        .animate-eveCelebrate { animation: eveCelebrate 0.75s ease-in-out infinite; }
        .animate-eveFix       { animation: eveFix       0.9s  ease-in-out infinite; }
        .animate-eveChat      { animation: eveChat      0.55s ease-in-out infinite; }
        .animate-eveCount     { animation: eveCount     1.6s  ease-in-out infinite; }
        .animate-eveAnalyze   { animation: eveAnalyze   2.2s  ease-in-out infinite; }
        .animate-eveGreet     { animation: eveGreet     1.1s  ease-in-out infinite; }
        .animate-evePoint     { animation: evePoint     0.65s ease-in-out infinite; }
        .animate-eveThink     { animation: eveThink     2.4s  ease-in-out infinite; }
      `}</style>
    </div>
  )
}

function CapIcon({ name, color, size = 12 }: { name: string; color: string; size?: number }) {
  const s = size
  const icons: Record<string, React.ReactElement> = {
    mail: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <rect x="1" y="3" width="14" height="10" rx="2" stroke={color} strokeWidth="1.5"/>
        <path d="M1 5l7 5 7-5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    calendar: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <rect x="1" y="3" width="14" height="12" rx="2" stroke={color} strokeWidth="1.5"/>
        <path d="M1 7h14" stroke={color} strokeWidth="1.5"/>
        <path d="M5 1v4M11 1v4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        <rect x="4" y="10" width="2" height="2" rx="0.5" fill={color}/>
        <rect x="7.5" y="10" width="2" height="2" rx="0.5" fill={color}/>
      </svg>
    ),
    edit: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <path d="M10.5 2.5l3 3-8.5 8.5H2v-3l8.5-8.5z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M8.5 4.5l3 3" stroke={color} strokeWidth="1.5"/>
      </svg>
    ),
    search: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <circle cx="6.5" cy="6.5" r="4.5" stroke={color} strokeWidth="1.5"/>
        <path d="M10 10l4 4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    trending: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <path d="M1 12l4-4 3 3 7-7" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10 4h5v5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    chat: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <path d="M14 3H2a1 1 0 00-1 1v7a1 1 0 001 1h3l2 2 2-2h5a1 1 0 001-1V4a1 1 0 00-1-1z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M4 7h8M4 9.5h5" stroke={color} strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
    receipt: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <path d="M3 1h10v14l-2-1.5-2 1.5-2-1.5L5 15 3 13.5V1z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M6 5h4M6 7.5h4M6 10h2" stroke={color} strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
    chart: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <path d="M1 13h14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        <rect x="2" y="7" width="2.5" height="6" rx="0.5" fill={color} opacity="0.6"/>
        <rect x="6" y="4" width="2.5" height="9" rx="0.5" fill={color} opacity="0.8"/>
        <rect x="10" y="2" width="2.5" height="11" rx="0.5" fill={color}/>
      </svg>
    ),
    users: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <circle cx="6" cy="5" r="2.5" stroke={color} strokeWidth="1.5"/>
        <path d="M1 14c0-3 2-4.5 5-4.5s5 1.5 5 4.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="12" cy="5" r="2" stroke={color} strokeWidth="1.3" opacity="0.6"/>
        <path d="M14 14c0-2.5-1.3-3.8-3-4.2" stroke={color} strokeWidth="1.3" strokeLinecap="round" opacity="0.6"/>
      </svg>
    ),
    package: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <path d="M8 1l6 3.5v7L8 15l-6-3.5v-7L8 1z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M8 1v13M2 4.5l6 3.5 6-3.5M5 2.5l6 3.5" stroke={color} strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      </svg>
    ),
    globe: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="6.5" stroke={color} strokeWidth="1.5"/>
        <path d="M8 1.5c-2 2-3 4-3 6.5s1 4.5 3 6.5M8 1.5c2 2 3 4 3 6.5s-1 4.5-3 6.5" stroke={color} strokeWidth="1.2"/>
        <path d="M1.5 8h13" stroke={color} strokeWidth="1.2" strokeLinecap="round"/>
        <path d="M2.5 5h11M2.5 11h11" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
      </svg>
    ),
    server: (
      <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
        <rect x="1" y="2" width="14" height="4" rx="1.5" stroke={color} strokeWidth="1.5"/>
        <rect x="1" y="9" width="14" height="4" rx="1.5" stroke={color} strokeWidth="1.5"/>
        <circle cx="12" cy="4" r="1" fill={color}/>
        <circle cx="12" cy="11" r="1" fill={color}/>
      </svg>
    ),
  }
  return icons[name] ?? null
}

function CardUI({ id, active }: { id: string; active: boolean }) {
  if (id === 'email') return (
    <div className="space-y-1.5">
      {[
        { from: 'AWS Billing', subj: 'Invoice #4821 overdue', dot: 'bg-red-400', time: '2m' },
        { from: 'Ahmed · TechCorp', subj: 'Partnership proposal', dot: 'bg-blue-400', time: '14m' },
        { from: 'Marketing', subj: 'Campaign results ready', dot: 'bg-slate-500', time: '1h' },
      ].map((m, i) => (
        <div key={i} className="flex items-center gap-2 px-2 py-1.5 rounded-lg bg-black/20 border border-white/[0.06]">
          <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${m.dot}`} />
          <div className="min-w-0 flex-1">
            <div className="flex justify-between items-baseline gap-1">
              <span className="text-[9px] font-semibold text-white/90 truncate">{m.from}</span>
              <span className="text-[8px] text-white/25 flex-shrink-0">{m.time}</span>
            </div>
            <div className="text-[8px] text-white/40 truncate">{m.subj}</div>
          </div>
        </div>
      ))}
    </div>
  )

  if (id === 'calendar') return (
    <div>
      <div className="grid grid-cols-7 mb-1.5">
        {['M','T','W','T','F','S','S'].map((d,i) => (
          <div key={i} className="text-center text-[7px] text-white/25 font-medium pb-1">{d}</div>
        ))}
        {[17,18,19,20,21,22,23].map((d) => (
          <div key={d} className={`mx-auto flex items-center justify-center w-4 h-4 rounded-full text-[8px] font-medium
            ${d === 19 ? 'bg-purple-500 text-white' : d === 17 ? 'bg-white/10 text-white/70' : 'text-white/35'}`}>{d}</div>
        ))}
      </div>
      <div className="space-y-1">
        {[
          { time: '11:00', label: 'Q1 Review', color: 'bg-purple-500' },
          { time: '15:00', label: 'Riyadh call', color: 'bg-blue-500' },
          { time: '18:00', label: 'Flight BKK→RUH', color: 'bg-emerald-500' },
        ].map((ev, i) => (
          <div key={i} className="flex items-center gap-2 px-2 py-1 rounded-lg bg-black/20 border border-white/[0.06]">
            <div className={`w-0.5 h-4 rounded-full flex-shrink-0 ${ev.color}`} />
            <span className="text-[8px] text-white/35 flex-shrink-0 w-8 font-mono">{ev.time}</span>
            <span className="text-[8px] text-white/80 truncate">{ev.label}</span>
          </div>
        ))}
      </div>
    </div>
  )

  if (id === 'content') return (
    <div className="space-y-1.5">
      <div className="rounded-lg bg-black/30 border border-white/[0.07] p-2">
        <div className="flex items-center gap-1.5 mb-1.5">
          <span className="text-[8px] text-rose-400/70 font-mono">article.md</span>
          <span className="ml-auto text-[7px] px-1.5 py-0.5 rounded-full bg-emerald-500/15 text-emerald-400 border border-emerald-500/20">SEO 94</span>
        </div>
        <div className="space-y-1">
          <div className="h-1 bg-white/15 rounded-full w-full" />
          <div className="h-1 bg-white/10 rounded-full w-5/6" />
          <div className="h-1 bg-white/[0.07] rounded-full w-4/6" />
          <div className="h-1 bg-white/[0.04] rounded-full w-3/6" />
        </div>
      </div>
      <div className="flex gap-1">
        {[['EN','rose'],['AR','rose'],['FR','slate']].map(([lang,c],i) => (
          <div key={i} className={`flex-1 text-center text-[8px] py-1 rounded-lg border font-semibold
            ${i < 2 ? 'bg-rose-500/15 border-rose-500/20 text-rose-300' : 'bg-white/[0.03] border-white/[0.07] text-white/20'}`}>{lang}</div>
        ))}
      </div>
      <div className="flex flex-wrap gap-1">
        {['Blog','Twitter','LinkedIn','IG'].map((p,i) => (
          <span key={i} className="text-[7px] px-1.5 py-0.5 rounded bg-white/[0.06] text-white/45 border border-white/[0.06]">{p}</span>
        ))}
      </div>
    </div>
  )

  if (id === 'research') return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-2 mb-1">
        <div className="flex-1 h-1 bg-white/[0.08] rounded-full overflow-hidden">
          <div className="h-full bg-emerald-400 rounded-full transition-all duration-[1500ms] ease-out"
            style={{width: active ? '78%' : '0%'}} />
        </div>
        <span className="text-[8px] text-emerald-400 font-semibold">78%</span>
      </div>
      {[
        { label: 'Competitor pricing', delta: '+12%', color: 'text-red-400' },
        { label: 'Market size (TAM)', delta: '$4.2B', color: 'text-blue-400' },
        { label: 'New RFP matches', delta: '3 found', color: 'text-emerald-400' },
        { label: '47-page report', delta: '→ 1 page', color: 'text-purple-400' },
      ].map((r, i) => (
        <div key={i} className="flex justify-between items-center px-2 py-1 rounded-lg bg-black/20 border border-white/[0.05]">
          <span className="text-[8px] text-white/40">{r.label}</span>
          <span className={`text-[8px] font-semibold ${r.color}`}>{r.delta}</span>
        </div>
      ))}
    </div>
  )

  if (id === 'sales') return (
    <div className="space-y-1.5">
      <div className="grid grid-cols-3 gap-1">
        {[['Lead','8','white'],['Proposal','3','amber'],['Closed','1','emerald']].map(([s,n,c],i) => (
          <div key={i} className={`text-center rounded-lg py-1.5 border
            ${c === 'emerald' ? 'bg-emerald-500/10 border-emerald-500/20' : c === 'amber' ? 'bg-amber-500/10 border-amber-500/20' : 'bg-white/[0.04] border-white/[0.08]'}`}>
            <div className={`text-[12px] font-bold ${c === 'emerald' ? 'text-emerald-400' : c === 'amber' ? 'text-amber-400' : 'text-white/50'}`}>{n}</div>
            <div className="text-[7px] text-white/25 mt-0.5">{s}</div>
          </div>
        ))}
      </div>
      {[
        { name: 'TechCorp', val: '$12K', badge: '🔥 Hot', bc: 'text-orange-400' },
        { name: 'RealEstate Co', val: '$8K', badge: '⏳ Follow-up', bc: 'text-amber-400' },
        { name: 'StartupXYZ', val: '$4K', badge: '✅ Closed', bc: 'text-emerald-400' },
      ].map((d, i) => (
        <div key={i} className="flex items-center gap-2 px-2 py-1 rounded-lg bg-black/20 border border-white/[0.05]">
          <span className="text-[8px] text-white/70 flex-1 font-medium truncate">{d.name}</span>
          <span className="text-[8px] font-bold text-white/40">{d.val}</span>
          <span className={`text-[7px] flex-shrink-0 ${d.bc}`}>{d.badge}</span>
        </div>
      ))}
    </div>
  )

  if (id === 'ops') return (
    <div className="space-y-1.5">
      {[
        { label: 'CPU', val: 23, color: 'bg-cyan-400', tc: 'text-cyan-400' },
        { label: 'RAM', val: 58, color: 'bg-blue-400', tc: 'text-blue-400' },
        { label: 'Disk', val: 41, color: 'bg-indigo-400', tc: 'text-indigo-400' },
      ].map((m, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="text-[8px] text-white/35 w-6 flex-shrink-0 font-mono">{m.label}</span>
          <div className="flex-1 h-1.5 rounded-full bg-white/[0.06] overflow-hidden">
            <div className={`h-full rounded-full ${m.color} transition-all duration-1000 ease-out`}
              style={{width: active ? `${m.val}%` : '0%', transitionDelay: `${i * 200}ms`}} />
          </div>
          <span className={`text-[8px] w-5 text-right font-mono ${m.tc}`}>{m.val}%</span>
        </div>
      ))}
      <div className="mt-0.5 space-y-1">
        {[
          { icon: '✅', msg: 'SSL renewed — Dec 2027' },
          { icon: '💾', msg: 'Backup done — 2.3 GB' },
          { icon: '🔧', msg: 'Memory leak fixed' },
        ].map((l, i) => (
          <div key={i} className="flex items-center gap-1.5 px-2 py-0.5 rounded bg-black/20 border border-white/[0.05]">
            <span className="text-[9px]">{l.icon}</span>
            <span className="text-[8px] text-white/45">{l.msg}</span>
          </div>
        ))}
      </div>
    </div>
  )


  if (id === 'whatsapp') return (
    <div className="space-y-1.5">
      {[
        { name: 'Ahmed · TechCorp', msg: 'Following up on our proposal 👋', time: '9:04', unread: false },
        { name: 'Sara (Lead)', msg: 'Are you available this week?', time: '9:02', unread: true },
        { name: 'Khaled', msg: 'Invoice received, thanks!', time: '8:58', unread: false },
      ].map((m, i) => (
        <div key={i} className="flex items-center gap-2 px-2 py-1.5 rounded-lg bg-black/20 border border-white/[0.06]">
          <div className="w-6 h-6 rounded-full bg-gradient-to-br from-green-400 to-emerald-600 flex items-center justify-center text-[9px] font-bold text-white flex-shrink-0">{m.name[0]}</div>
          <div className="min-w-0 flex-1">
            <div className="flex justify-between items-baseline">
              <span className="text-[9px] font-semibold text-white/90 truncate">{m.name}</span>
              <span className="text-[7px] text-white/25 flex-shrink-0 ml-1">{m.time}</span>
            </div>
            <div className="text-[8px] text-white/40 truncate">{m.msg}</div>
          </div>
          {m.unread && <div className="w-1.5 h-1.5 rounded-full bg-green-400 flex-shrink-0" />}
        </div>
      ))}
      <div className="flex justify-between items-center px-1">
        <span className="text-[8px] text-white/30">34 sent today</span>
        <span className="text-[8px] text-emerald-400 font-medium">12 replied ✓</span>
      </div>
    </div>
  )

  if (id === 'invoice') return (
    <div className="space-y-1.5">
      <div className="rounded-lg bg-black/30 border border-white/[0.07] p-2">
        <div className="flex justify-between items-center mb-1.5">
          <span className="text-[8px] text-violet-400/80 font-mono">INV-2026-047</span>
          <span className="text-[7px] px-1.5 py-0.5 rounded-full bg-amber-500/15 text-amber-400 border border-amber-500/20">Pending</span>
        </div>
        {[
          { desc: 'AI Agent Setup', amt: '$299' },
          { desc: 'Core Plan × 3 mo', amt: '$510' },
          { desc: 'Integration Add-on', amt: '$45' },
        ].map((line, i) => (
          <div key={i} className="flex justify-between text-[8px] py-0.5 border-b border-white/[0.04] last:border-0">
            <span className="text-white/40">{line.desc}</span>
            <span className="text-white/70 font-medium">{line.amt}</span>
          </div>
        ))}
        <div className="flex justify-between text-[9px] font-bold mt-1.5 pt-1 border-t border-white/[0.08]">
          <span className="text-white/60">Total</span>
          <span className="text-violet-300">$854</span>
        </div>
      </div>
      <div className="flex gap-1">
        {[['Sent','emerald'],['Viewed','blue'],['Paid','slate']].map(([s,c],i) => (
          <div key={i} className={`flex-1 text-center py-1 rounded-lg text-[7px] font-semibold border ${i===0?'bg-emerald-500/15 border-emerald-500/20 text-emerald-400':i===1?'bg-blue-500/15 border-blue-500/20 text-blue-400':'bg-white/[0.03] border-white/[0.07] text-white/20'}`}>{s}</div>
        ))}
      </div>
    </div>
  )

  if (id === 'analytics') return (
    <div className="space-y-1.5">
      <div className="flex items-end gap-1 h-10 mb-1 px-1">
        {[40,65,52,78,60,90,82].map((h,i) => (
          <div key={i} className="flex-1 rounded-t-sm transition-all duration-700"
            style={{height: active ? `${h}%` : '0%', background: i===5?'#f97316':'rgba(249,115,22,0.3)', transitionDelay: `${i*80}ms`}} />
        ))}
      </div>
      <div className="flex justify-between text-[7px] text-white/25 px-1 mb-1">
        {['M','T','W','T','F','S','S'].map((d,i) => <span key={i}>{d}</span>)}
      </div>
      {[
        { kpi: 'Revenue', val: '+18%', color: 'text-emerald-400' },
        { kpi: 'New Leads', val: '+34%', color: 'text-blue-400' },
        { kpi: 'Churn Rate', val: '-6%', color: 'text-red-400' },
      ].map((k,i) => (
        <div key={i} className="flex justify-between items-center px-2 py-0.5 rounded bg-black/20 border border-white/[0.05]">
          <span className="text-[8px] text-white/40">{k.kpi}</span>
          <span className={`text-[8px] font-bold ${k.color}`}>{k.val}</span>
        </div>
      ))}
    </div>
  )

  if (id === 'hr') return (
    <div className="space-y-1.5">
      {[
        { name: 'Sara Al-Rashid', score: 92, status: '✅ Shortlisted', sc: 'text-emerald-400' },
        { name: 'James Okafor', score: 87, status: '✅ Shortlisted', sc: 'text-emerald-400' },
        { name: 'Lena Müller', score: 74, status: '⏳ Review', sc: 'text-amber-400' },
      ].map((c,i) => (
        <div key={i} className="px-2 py-1.5 rounded-lg bg-black/20 border border-white/[0.06]">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 rounded-full bg-gradient-to-br from-pink-400 to-rose-600 flex items-center justify-center text-[8px] font-bold text-white flex-shrink-0">{c.name[0]}</div>
            <span className="text-[9px] font-semibold text-white/85 flex-1 truncate">{c.name}</span>
            <span className={`text-[10px] font-bold flex-shrink-0 ${c.sc}`}>{c.score}</span>
          </div>
          <div className="text-[7px] mt-0.5 text-white/35 pl-7">{c.status}</div>
        </div>
      ))}
    </div>
  )

  if (id === 'orders') return (
    <div className="space-y-1.5">
      {[
        { id: 'ORD-441', item: 'Server components', status: 'Delivered', color: 'bg-emerald-400', tc: 'text-emerald-400' },
        { id: 'ORD-442', item: 'Office supplies', status: 'In Transit', color: 'bg-blue-400', tc: 'text-blue-400' },
        { id: 'ORD-443', item: 'Marketing print', status: 'Delayed', color: 'bg-red-400', tc: 'text-red-400' },
        { id: 'ORD-444', item: 'Laptops × 3', status: 'Processing', color: 'bg-amber-400', tc: 'text-amber-400' },
      ].map((o,i) => (
        <div key={i} className="flex items-center gap-2 px-2 py-1 rounded-lg bg-black/20 border border-white/[0.05]">
          <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${o.color}`} />
          <span className="text-[8px] font-mono text-white/30 flex-shrink-0">{o.id}</span>
          <span className="text-[8px] text-white/65 truncate flex-1">{o.item}</span>
          <span className={`text-[7px] font-medium flex-shrink-0 ${o.tc}`}>{o.status}</span>
        </div>
      ))}
    </div>
  )

  if (id === 'translator') return (
    <div className="space-y-1.5">
      <div className="rounded-lg bg-black/30 border border-white/[0.07] p-2 mb-1">
        <div className="text-[7px] text-white/30 mb-1 flex items-center gap-1">
          <span className="w-2 h-2 rounded-full bg-teal-400/60 inline-block" />EN · Source
        </div>
        <div className="space-y-0.5">
          <div className="h-1 bg-white/15 rounded-full w-full" />
          <div className="h-1 bg-white/10 rounded-full w-4/5" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-1">
        {[['AR','العربية'],['FR','Français'],['DE','Deutsch'],['ZH','中文']].map(([code,name],i) => (
          <div key={i} className="px-2 py-1 rounded-lg bg-black/20 border border-teal-500/15 flex items-center gap-1.5">
            <span className="text-[8px] font-bold text-teal-400 flex-shrink-0 w-4">{code}</span>
            <div className="flex-1 h-1 bg-teal-400/10 rounded-full overflow-hidden">
              <div className="h-full bg-teal-400/60 rounded-full transition-all duration-1000"
                style={{width: active ? '100%' : '0%', transitionDelay: `${i*120}ms`}} />
            </div>
          </div>
        ))}
      </div>
      <div className="text-center text-[7px] text-teal-400/50">+6 more languages ready</div>
    </div>
  )

  return null
}

function CapCard({ cap, active, highlight = false, compact = false }: {
  cap: typeof capSet1[0]; active: boolean; highlight?: boolean; compact?: boolean
}) {
  return (
    <div
      className={`rounded-2xl border transition-all duration-500 ease-out overflow-hidden relative p-3 flex flex-col
        ${active ? 'scale-[1.00]' : 'opacity-60 scale-100'}
        ${compact ? 'min-w-[210px]' : 'h-[155px] lg:h-[185px]'}
      `}
      style={{
        background: active ? '#11121a' : 'rgba(255,255,255,0.04)',
        borderColor: active ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.08)',
        boxShadow: active ? `0 0 35px ${cap.accentColor}18, 0 12px 40px rgba(0,0,0,0.6)` : 'none',
      }}
    >
      {highlight && (
        <div className="absolute inset-0 animate-pulse rounded-2xl pointer-events-none"
          style={{ background: `radial-gradient(circle at 50% 0%, ${cap.accentColor}25, transparent 60%)` }} />
      )}
      {active && (
        <div className="absolute top-0 left-6 right-6 h-px"
          style={{ background: `linear-gradient(90deg, transparent, ${cap.accentColor}70, transparent)` }} />
      )}

      <div className={`flex items-center gap-2 ${active ? "mb-3" : "mb-0"}`}>
        <div className="w-6 h-6 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{
            background: active ? `${cap.accentColor}18` : 'rgba(255,255,255,0.04)',
            border: `1px solid ${active ? cap.accentColor + '35' : 'rgba(255,255,255,0.06)'}`,
          }}>
          <CapIcon name={cap.icon} color={active ? cap.accentColor : 'rgba(255,255,255,0.55)'} size={14} />
        </div>
        <span className={`text-[10px] font-semibold tracking-wide transition-colors ${active ? 'text-white/85' : 'text-white/55'}`}>
          {cap.title}
        </span>
        {active && (
          <div className="ml-auto flex items-center gap-1.5 flex-shrink-0">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-[8px] text-emerald-400/70 font-medium">live</span>
          </div>
        )}
      </div>

      <div className={`transition-opacity duration-500 overflow-hidden flex-1 min-h-0 ${active ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <CardUI id={cap.id} active={active} />
      </div>
    </div>
  )
}